import Report from '../Report';
import FieldSet from '../FieldSet';
import Parameter from '../Parameter';

export default class RadioGroupField extends Parameter {
    /**
     * Dictionnaire
     * @key Nom
     * @value Valeur
     */
    public Options: Array<{ key: string; value: string }>;

    /**
     * Constructeur RadioGroup
     * @param Name 
     * @param Label 
     * @param Type 
     * @param EmptyText 
     * @param Selected 
     * @param Option 
     * @param Listeners 
     * @param Options Extends
     */
    constructor(Name: string = '', Label: string = '', Type: string = 'RadioGroup', EmptyText: string = '', Selected: string = '', Option: object = {}, Listeners: Array<{ key: string; value: string }> = [], Options: Array<{ key: string; value: string }> = [{key: '', value: ''}] ) {
        super(Name, Label, Type, EmptyText, Selected, Option, Listeners);
        this.Options = Options;
    }

    //#region Methode Static
    
    // Enregistre la class dans la class Parent
    static {
        Parameter.registerSubclass(RadioGroupField); 
    }

    //#endregion

    /**
     * Check si RadioGroup à des valeurs
     * @returns boolean
     */
    override HasValue(): boolean {
        return this.Options.length > 0;
    }
    
    /**
     * Propriété filtrées pour la création d'un objet RadioGroup
     * @returns Dictionnaires Nom / Valeurs
     */
    override getProperties(): Array<[string, any]>{
        return Object.entries(this).filter(([key]) => 
            this.keysToFilter.includes(key) )
    }

    // Créations des clé pour filtrer les propriété de RadioGroup
    override keysToFilter: string[] =  ['Options'];

    override create() : RadioGroupField{
        return new RadioGroupField(this.Name, this.Label, this.Type, this.EmptyText, this.Selected, this.Option, this.Listeners, this.Options)
    }
}